export const rosterFormInfo = {
  overview: {
    title: 'Come leggere questo form',
    body:
      'Qui stai definendo le regole del roster: composizione delle fazioni, budget iniziale, filtri disponibili e ruoli speciali come Main Eventer o Backstage.'
  },
  startDate: {
    title: 'Data inizio punteggio',
    body:
      'Da questa data iniziano a contare i punti del roster. Gli show precedenti non influenzano la stagione di questo roster.'
  },
   name: {
    title: 'Nome roster',
    body:
      'Serve a identificare il roster dentro il sito. Scegli un nome chiaro, cosi i giocatori possono riconoscerlo facilmente.'
  },
  gameType: {
    title: 'Tipo di gioco',
    body:
      'Definisce il formato del roster. Usalo per distinguere tra esperienze con regole e flussi diversi.'
  },
  slotsAndCredits: {
    title: 'Wrestler, crediti e scambi',
    body:
      'Questa sezione imposta la struttura base di ogni fazione: quanti wrestler può avere, con quale budget parte e quanti scambi può fare.'
  },
  composition: {
    title: 'Vincoli di composizione',
    body:
      'Questi minimi obbligano ogni fazione a rispettare una composizione minima per genere. Se lasci 0, non imponi alcun vincolo.'
  },
  options: {
    title: 'Filtri e regole speciali',
    body:
      'Qui scegli quali wrestler possono entrare nel roster e se la line-up prevede ruoli speciali. Sono impostazioni che cambiano davvero il modo di giocare!'
  },
  onlyMainRoster: {
    title: 'Solo Main Roster',
    body:
      'Permette di selezionare solo wrestler del main roster. Se attivo, il filtro NXT viene escluso.'
  },
  onlyNXT: {
    title: 'Solo NXT',
    body:
      'Permette di selezionare solo wrestler di NXT. Se attivo, il filtro Main Roster viene escluso.'
  },
  backstage: {
    title: 'Backstage',
    body:
      'Abilita gli slot Backstage nella line-up. I wrestler messi in Backstage fanno parte della fazione ma non generano punti attivi nello show.'
  },
  backstageCount: {
    title: 'Numero wrestler in Backstage',
    body:
      'Imposta quanti slot Backstage ha ogni fazione. Il massimo dipende dagli slot totali e dall eventuale presenza del Main Eventer.'
  },
  mainEventer: {
    title: 'Main Eventer',
    body:
      'Abilita il ruolo Main Eventer nella line-up. Il wrestler scelto ottiene il bonus x2 finche resta il Main Eventer attivo del roster.'
  },
  mainEventerTiming: {
    title: 'Durata e cooldown del Main Eventer',
    body:
      'Qui definisci per quanto tempo il Main Eventer resta attivo e per quanto tempo deve poi attendere prima di poter essere riselezionato. Se non cambi nulla, il default e 2 settimane attive e 2 settimane di pausa.'
  },
  gmMode: {
    title: 'Modalita GM',
    body:
      'Trasforma il roster in una modalita piu strategica legata ai GM match, con gestione e punteggi diversi dal fantasy classico.'
  },
  participants: {
    title: 'Partecipanti',
    body:
      'Se attivi questa opzione puoi invitare subito i giocatori via email. Se la lasci spenta, potrai aggiungerli in un secondo momento.'
  },
  image: {
    title: 'Immagine roster',
    body:
      'Impoosta una copertina usata per rendere il roster piu riconoscibile nelle pagine del sito.'
  }
}
